var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "27px",
    viewBox: "0 0 25 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "profile-icon--black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-1263.000000, -101.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-icon--black",
    transform: "translate(1263.892000, 102.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1404821,0 C14.9822755,0 18.108,3.12550936 18.108,6.9675179 C18.108,10.8744906 14.9824906,14 11.1404821,14 C7.23350936,14 4.108,10.8744906 4.108,6.9675179 C4.108,3.12572447 7.23350936,0 11.1404821,0 Z M11.1404821,1.62780492 C8.1452023,1.62780492 5.80094121,4.03707323 5.80094121,6.96734581 C5.80094121,9.96262561 8.14515928,12.3718509 11.1404821,12.3718509 C14.0707117,12.3718509 16.480023,9.96258259 16.480023,6.96734581 C16.480023,4.03711625 14.0707547,1.62780492 11.1404821,1.62780492 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5872505,15 C19.2348247,15 23.108,19.3024264 23.108,24.5462404 C23.108,25.1512532 21.5587299,25.1512532 21.5587299,24.5462404 C21.5587299,20.243814 18.4007023,16.6807637 14.5871718,16.6807637 L8.62859198,16.6807637 C4.75545604,16.6807637 1.5975859,20.2437252 1.5975859,24.5462404 C1.5975859,25.1512532 0.108,25.1512532 0.108,24.5462404 C0.108,19.3027373 3.92145172,15 8.62874946,15 L14.5872505,15 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconBlack);
export default __webpack_public_path__ + "static/media/profile-icon--black.1c881f473a4f0351e4b9ed8ec288cf48.svg";
export { ForwardRef as ReactComponent };